import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Auth } from '../models/auth';
import { ResponseBase } from '../models/response-base';
import { CedenteGestor } from '../models/cedentegestor';
import { GestorConvite } from '../models/gestor-convite';
import { GestorConviteCadastro } from '../models/gestor-convite-cadastro';
import { GestorRegistro } from '../models/gestor-registro';
import { OpcoesGestorPaginado } from '../models/opcoes-gestor-paginado';
import { GestorPaged } from '../models/gestor-paged';
import { OpcoesGestorInvitePaginado } from '../models/opcoes-gestor-invite-paginado';
import { GestorInvitePaged } from '../models/gestor-invite-paged';
import { GestorBloqueio } from '../models/gestor-bloqueio';

@Injectable({
    providedIn: 'root'
})
export class GestorService {

    API: string = environment.API + 'Portal/gestores';

    constructor(private http: HttpClient) { }

    validarCPF(documento: string): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.API}/cpf/${documento}`);
    }

    validarRegistro(gestorRegistro: GestorRegistro): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.API}/validar/registro`, gestorRegistro);
    }

    confirmLogin(email: string, senha: string): Observable<ResponseBase<Auth>> {
        return this.http.post<ResponseBase<Auth>>(`${this.API}/confirmarlogin`, { email, senha });
    }

    getGestorCedenteElegibility(cpfGestor: string, cnpjCedente: string): Observable<ResponseBase<boolean>> {
        return this.http.get<ResponseBase<boolean>>(`${this.API}/cpf/${cpfGestor}/cedentes/cnpj/${cnpjCedente}/elegivel`);
    }

    getAll(cedenteGuid: string): Observable<ResponseBase<CedenteGestor[]>> {
        return this.http.get<ResponseBase<CedenteGestor[]>>(`${this.API}/cedentes/${cedenteGuid}`);
    }

    GetAllPaginated(cedenteGuid: string, opcoes: OpcoesGestorPaginado): Observable<ResponseBase<GestorPaged>> {
        return this.http.post<ResponseBase<GestorPaged>>(`${this.API}/cedentes/${cedenteGuid}/paginado`, opcoes);
    }

    getGestor(gestorGuid: string, cedenteGuid: string): Observable<ResponseBase<CedenteGestor>> {
        return this.http.get<ResponseBase<CedenteGestor>>(`${this.API}/${gestorGuid}/cedentes/${cedenteGuid}`);
    }

    delete(cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<CedenteGestor>> {
        return this.http.delete<ResponseBase<CedenteGestor>>(`${this.API}/${gestorGuid}/cedentes/${cedenteGuid}`);
    }

    bloquear(gestorBloqueio: GestorBloqueio) {
        return this.http.put<ResponseBase<CedenteGestor>>(`${this.API}/bloquear`, gestorBloqueio);
    }

    desbloquear(gestorBloqueio: GestorBloqueio) {
        return this.http.put<ResponseBase<CedenteGestor>>(`${this.API}/desbloquear`, gestorBloqueio);
    }

    invite(gestorConviteCadastro: GestorConviteCadastro, gestorGuid: string, cedenteGuid: string): Observable<ResponseBase<GestorConvite>> {
        return this.http.post<ResponseBase<GestorConvite>>(`${this.API}/${gestorGuid}/cedentes/${cedenteGuid}/invite`, gestorConviteCadastro);
    }

    edit(gestorConviteCadastro: GestorConviteCadastro, gestorGuid: string, cedenteGuid: string): Observable<ResponseBase<GestorConvite>> {
        return this.http.put<ResponseBase<GestorConvite>>(`${this.API}/${gestorGuid}/cedentes/${cedenteGuid}/edit`, gestorConviteCadastro);
    }

    getAllInvites(cedenteGuid: string): Observable<ResponseBase<GestorConvite[]>> {
        return this.http.get<ResponseBase<GestorConvite[]>>(`${this.API}/cedentes/${cedenteGuid}/invite`);
    }

    getAllInvitesPaginated(cedenteGuid: string, opcoes: OpcoesGestorInvitePaginado): Observable<ResponseBase<GestorInvitePaged>> {
        return this.http.post<ResponseBase<GestorInvitePaged>>(`${this.API}/cedentes/${cedenteGuid}/invite/paginado`, opcoes);
    }

    cancelInvite(inviteGuid: string, gestorGuid: string, cedenteGuid: string): Observable<ResponseBase<GestorConvite>> {
        return this.http.delete<ResponseBase<GestorConvite>>(`${this.API}/${gestorGuid}/cedentes/${cedenteGuid}/invite/${inviteGuid}/cancel`);
    }

    solicitarPin(cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.API}/pin/${gestorGuid}/cedentes/${cedenteGuid}`);
    }
    
    confirmarPin(cedenteGuid: string, gestorGuid: string, token: number): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.API}/pin/confirmar/${gestorGuid}/cedentes/${cedenteGuid}`, token );
    }
}
